module.exports = __webpack_public_path__ + "static/media/brazil.3fc8860c.png";